<!--
 * @Description: 创意工厂/素材库/列表形式展示
 * @Author: hasayake
 * @Date: 2020-06-16 11:10:04
 * @LastEditTime: 2020-07-06 11:18:38
 * @LastEditors: Please set LastEditors
-->

<template>
  <div class="material-list-show">
    <el-table
      ref="multipleTable"
      :data="fileList"
      @selection-change="handleSelectionChange"
      :height="tableHeight"
    >
      <el-table-column type="" width="55">
        <template slot="header" slot-scope="">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          ></el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            v-model="scope.row.check"
            :disabled="scope.row.dirType === 1"
            @change="handleCheckOneChange(scope.row)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="素材名称" prop="fileName" width="300">
        <template slot-scope="scope">
          <div class="material-name">
            <!-- 文件状态展示 type=1 -->
            <div
              v-if="scope.row.type === 1"
              class="folder-show"
              :style="{
                backgroundImage: `url(${scope.row.fileThumbnailPath})`
              }"
            >
              <img
                v-if="scope.row.docType === 1"
                src="../../assets/images/video-play-icon.png"
                alt
                class="video-play"
              />
            </div>
            <!-- 文件夹状态 type=2 -->
            <img
              width="40"
              @click.stop="folderClickHandler(scope.row)"
              :src="scope.row.hasChild ? folderImgs.have : folderImgs.empty"
              alt
              v-else
            />
            <span class="item-name">{{ scope.row.fileName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="格式" prop="fileSuffix" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="createDate" align="center"></el-table-column>
      <el-table-column label="上传平台时间" prop="uploadTime" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.uploadTime || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="平台审核状态" prop="uploadStatus" align="center">
        <template slot-scope="scope">
          <!-- 0  是未上传，1是已上传 -->
          <span>{{ scope.row.uploadStatus ? "已上传" : "未上传" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              :disabled="scope.row.type !== 1"
              size="small"
              type="text"
              @click="downHandler(scope.row)"
              >下载</el-button
            >
            <el-button
              size="small"
              type="text"
              :disabled="scope.row.type !== 1"
              @click="openDetailBoxHandler(scope.row)"
              >查看详情</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <review-material
      v-show="reviews.show"
      :viewPath="reviews.path"
      @close="closeReviewHandler"
    />
  </div>
</template>

<script>
import { downloadFileByStream } from "@/assets/js/api";
import reviewMaterial from "@/components/ReviewMaterial.vue";

export default {
  name: "materialTableShow",

  components: {
    reviewMaterial
  },

  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      reviews: {
        show: false
      },
      headList: [
        { label: "素材名称", prop: "fileName" },
        { label: "创建时间", prop: "" },
        { label: "上传平台时间", prop: "" },
        { label: "平台审核状态", prop: "" },
        { label: "操作", prop: "" }
      ],
      folderImgs: {
        have: require("@/assets/images/folder-big-icon.png"),
        empty: require("@/assets/images/folder-big-none-icon.png")
      },
      tableHeight: Math.max(window.innerHeight, 720) - 300,
      checkAll: false,
      isIndeterminate: false
    };
  },

  methods: {
    openDetailBoxHandler(row) {
      console.log(row)
      this.$emit(
        "playVideo",
        row
      );
    },

    closeReviewHandler() {
      this.reviews.show = false;
    },

    handleSelectionChange(arr) {},

    downHandler(row) {
      downloadFileByStream(row.fileId).then(res => {
        const a = document.createElement("a");
        const href = URL.createObjectURL(res);
        a.href = href;
        a.download = `${row.fileName}.${row.fileSuffix}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      });
    },
    folderClickHandler(row) {
      // 文件夹双击进入
      if (row.type === 2) {
        this.$emit("itemDbClick", {
          name: row.fileName,
          id: row.fileId
        });
      }
    },
    handleCheckAllChange(val) {
      const result = [];
      this.isIndeterminate = false;
      if (this.checkAll) {
        for (let item of this.fileList) {
          this.$refs.multipleTable.toggleRowSelection(item, true);
          //我的收藏不可选中
          if (item.dirType !== 1) {
            result.push({
              fileId: item.fileId,
              type: item.type
            });
          }
        }
      }
      this.$emit("checkChange", result);
    },
    handleCheckOneChange(row) {
      const result = this.fileList.filter(item => {
        return !!item.check;
      });
      this.$emit("checkChange", result);
    },
    initCheckStatus() {
      if (!this.fileList.length) return;
      const isAll = this.isAllCheck();
      this.checkAll = isAll;
      const isCheck = this.haveCheck();
      this.isIndeterminate = !isAll && isCheck;
    },
    haveCheck() {
      // 检测是否有被选中的row
      return Array.from(this.fileList).some(item => {
        return !!item.check;
      });
      // return isCheck;
    },
    isAllCheck() {
      //检测是否全选
      return Array.from(this.fileList).every(item => {
        if (item.dirType !== 1) {
          return !!item.check;
        } else {
          return true;
        }
      });
      // return isAll;
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      const wh = Math.max(window.innerHeight, 720);
      this.tableHeight = wh - 300;
    });
    this.initCheckStatus();
    this.$nextTick(() => {});
  },
  watch: {
    fileList(v) {
      this.initCheckStatus();
    }
  }
};
</script>

<style lang="scss">
.material-list-show {
  .el-table th {
    background-color: #fafafa;
  }
  .material-name {
    display: flex;
    align-items: center;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;

    img {
      cursor: pointer;
    }

    .video-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 20px;
      height: 20px;
    }
  }

  .folder-show {
    position: relative;
    min-width: 40px;
    height: 40px;
    background-size: cover;
    background-position: center;
    border-radius: 4px;
  }

  .item-name {
    margin-left: 20px;
  }
}
</style>
